import { Directive, HostBinding, Input, OnChanges } from '@angular/core';

import { SupportLinkService } from '../../services/support-link/support-link.service';

/**
 * Meant to be a plug-and-play directive that can link to various support sites
 */
@Directive({
  selector: 'a[coreSupportLink], area[coreSupportLink]',
  standalone: false,
})
export class SupportLinkDirective implements OnChanges {
  @HostBinding() public href!: string;
  @HostBinding('attr.target') @Input() public target: string = '_blank';

  @Input() set generalSupport(value: boolean | '') {
    // putting "generalSupport" on the tag makes the boolean value true. false if it is not present on the tag
    // https://github.com/angular/angular/issues/14761#issuecomment-532889037
    this._generalSupport = value === '' || value;
  }
  get generalSupport() {
    return this._generalSupport;
  }

  private _generalSupport: boolean = false;

  constructor(private supportLinkService: SupportLinkService) {
    this.setHref();
  }

  public ngOnChanges(changes: {}) {
    this.setHref();
  }

  private setHref() {
    const supportTicketLink = this.supportLinkService.supportTicketLink;
    const generalSupportLink = this.supportLinkService.generalSupportLink;
    this.href = this.generalSupport ? generalSupportLink : supportTicketLink;
  }
}
